import { render, staticRenderFns } from "./home.vue?vue&type=template&id=edbdaa7c&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=edbdaa7c&lang=less&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=edbdaa7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbdaa7c",
  null
  
)

export default component.exports